<template>
  <div :class="['card card-modal', { 'card-standalone': standalone }]">
    <div class="row card-body">
      <div class="col-12 text-center mb-3">
        <h5 v-if="step === 'request'">Solicitar código</h5>
        <h5 v-else-if="step === 'validate'">Validar código</h5>
        <h5 v-else>Redefinir senha</h5>
      </div>

      <template v-if="step === 'request'">
        <div class="col-12 input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <font-awesome-icon icon="user" />
            </span>
          </div>
          <input
            v-model="form.login"
            @keyup.enter="solicitarCodigo()"
            type="text"
            class="form-control"
            placeholder="Login"
            aria-label="Login"
          >
        </div>
        <div class="col-12 mt-3">
          <button
            class="btn btn-md btn-primary btn-block"
            :disabled="loading"
            @click="solicitarCodigo()"
          >
            Enviar código por e-mail
          </button>
        </div>
      </template>

      <template v-else-if="step === 'validate'">
        <div class="col-12 input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <font-awesome-icon icon="user" />
            </span>
          </div>
          <input
            v-model="form.login"
            type="text"
            class="form-control"
            placeholder="Login"
            aria-label="Login"
            disabled
          >
        </div>

        <div class="col-12 input-group mt-3">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <font-awesome-icon icon="key" />
            </span>
          </div>
          <input
            v-model="form.codigo"
            @keyup.enter="validarCodigo()"
            type="text"
            maxlength="6"
            class="form-control"
            placeholder="Código recebido"
            aria-label="Código recebido"
          >
        </div>

        <div class="col-12 mt-3">
          <button
            class="btn btn-md btn-info btn-block"
            :disabled="loading"
            @click="validarCodigo()"
          >
            Validar código
          </button>
        </div>

        <div class="col-12 mt-2 d-flex justify-content-between">
          <button
            class="btn btn-link p-0"
            type="button"
            :disabled="loading || resendCooldown > 0"
            @click="reenviarCodigo()"
          >
            Reenviar código
            <span v-if="resendCooldown > 0">({{ resendCooldown }}s)</span>
          </button>

          <button
            class="btn btn-link p-0 text-danger"
            type="button"
            :disabled="loading"
            @click="voltarInicio()"
          >
            Usar outro login
          </button>
        </div>
      </template>

      <template v-else>
        <div class="col-12 input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <font-awesome-icon icon="user" />
            </span>
          </div>
          <input
            v-model="form.login"
            type="text"
            class="form-control"
            placeholder="Login"
            aria-label="Login"
            disabled
          >
        </div>

        <div class="col-12 input-group mt-3">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <font-awesome-icon icon="key" />
            </span>
          </div>
          <input
            v-model="form.codigo"
            type="text"
            maxlength="6"
            class="form-control"
            placeholder="Código validado"
            aria-label="Código validado"
            disabled
          >
        </div>

        <div class="col-12 input-group mt-3">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <font-awesome-icon icon="lock" />
            </span>
          </div>
          <input
            v-model="form.password"
            @keyup.enter="redefinirSenha()"
            type="password"
            class="form-control"
            placeholder="Nova senha"
            aria-label="Nova senha"
          >
        </div>

        <div class="col-12 mt-3">
          <button
            class="btn btn-md btn-success btn-block"
            :disabled="loading"
            @click="redefinirSenha()"
          >
            Redefinir senha
          </button>
        </div>
      </template>

      <div class="col-12">
        <my-alert
          class="alert-danger text-center mt-3"
          @done="showError = false"
          :message="errorMessage"
          :show="showError"
          :timeout="10000"
        ></my-alert>
        <my-alert
          class="alert-success text-center mt-2"
          @done="showSuccess = false"
          :message="successMessage"
          :show="showSuccess"
          :timeout="8000"
        ></my-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    standalone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      step: 'request',
      form: {
        login: '',
        codigo: '',
        password: '',
      },
      loading: false,
      showError: false,
      errorMessage: '',
      showSuccess: false,
      successMessage: '',
      resendCooldown: 0,
      cooldownInterval: null,
    };
  },
  beforeDestroy() {
    this.clearCooldown();
  },
  methods: {
    clearMessages() {
      this.showError = false;
      this.showSuccess = false;
      this.errorMessage = '';
      this.successMessage = '';
    },
    setError(message) {
      this.errorMessage = message;
      this.showError = true;
    },
    setSuccess(message) {
      this.successMessage = message;
      this.showSuccess = true;
    },
    clearCooldown() {
      if (this.cooldownInterval) {
        clearInterval(this.cooldownInterval);
        this.cooldownInterval = null;
      }
      if (this.resendCooldown < 0) {
        this.resendCooldown = 0;
      }
    },
    startCooldown(seconds = 60) {
      this.clearCooldown();
      this.resendCooldown = seconds;
      this.cooldownInterval = setInterval(() => {
        this.resendCooldown -= 1;
        if (this.resendCooldown <= 0) {
          this.clearCooldown();
          this.resendCooldown = 0;
        }
      }, 1000);
    },
    voltarInicio() {
      this.clearCooldown();
      this.step = 'request';
      this.form.login = '';
      this.form.codigo = '';
      this.form.password = '';
      this.clearMessages();
    },
    async solicitarCodigo(isResend = false) {
      this.clearMessages();

      if (!this.form.login) {
        this.setError('Informe o login para continuar.');
        return;
      }

      try {
        this.loading = true;
        const response = await this.$http.post('/codigo-reset-senha-v3', { login: this.form.login });

        if (response.success) {
          this.step = 'validate';
          if (!isResend) {
            this.form.codigo = '';
          }
          this.setSuccess(response.response || 'Código enviado para o e-mail cadastrado.');
          this.startCooldown();
        } else {
          this.setError(response.response || 'Não foi possível enviar o código.');
        }
      } catch (error) {
        this.setError('Erro ao enviar o código. Tente novamente.');
      } finally {
        this.loading = false;
      }
    },
    async reenviarCodigo() {
      if (this.resendCooldown > 0 || this.loading) return;
      await this.solicitarCodigo(true);
    },
    async validarCodigo() {
      this.clearMessages();

      if (!this.form.codigo) {
        this.setError('Informe o código recebido.');
        return;
      }

      try {
        this.loading = true;
        const response = await this.$http.post('/validar-codigo-reset-v3', {
          login: this.form.login,
          codigo: this.form.codigo,
        });

        if (response.success) {
          this.setSuccess(response.response || 'Código validado com sucesso.');
          this.step = 'reset';
          this.clearCooldown();
        } else {
          this.setError(response.response || 'Código inválido.');
        }
      } catch (error) {
        this.setError('Erro ao validar o código. Tente novamente.');
      } finally {
        this.loading = false;
      }
    },
    async redefinirSenha() {
      this.clearMessages();

      if (!this.form.password || this.form.password.length < 8) {
        this.setError('A senha deve ter pelo menos 8 caracteres.');
        return;
      }

      try {
        this.loading = true;
        const response = await this.$http.post('/reset-senha-v3', {
          login: this.form.login,
          codigo: this.form.codigo,
          password: this.form.password,
        });

        if (response.success) {
          const message = response.response || 'Senha redefinida com sucesso. Faça login novamente.';
          this.setSuccess(message);
          this.$toasted.show(message, { icon: 'check', type: 'success' });
          this.$emit('close');
          if (this.standalone) {
            this.$router.push({ name: 'Login' });
          }
          this.voltarInicio();
        } else {
          this.setError(response.response || 'Erro ao redefinir senha.');
        }
      } catch (error) {
        this.setError('Erro ao redefinir senha. Tente novamente.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.card-standalone {
  max-width: 480px;
  margin: 0 auto;
}

.btn-link {
  font-size: 0.9rem;
}
</style>
